import styled from "styled-components";

export const MusicHallStatusFormStyled = styled.div`
  border-radius: 8px;
  padding: 20px;
  background-color: ${({ theme }) => theme.COLORS.WHITE_1};
  max-width: 400px;
  width: 100%;
  .f_tile {
    margin-bottom: 20px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
  }
  .input_wrap {
    margin-bottom: 16px;
  }

  .action_layout {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    .btn_action_wrap {
      max-width: 120px;
      width: 100%;
    }
  }

  .confirm_layout {
    position: fixed;
    inset: 0;
    z-index: 100;
    display: flex;
    padding: 20px;
    justify-content: center;
    align-items: center;
    .confirm_backdrop {
      position: absolute;
      inset: 0;
      background: ${({ theme }) => theme.COLORS.BLACK_1}66;
    }
    .confirm_body {
      position: relative;
      border-radius: 8px;
      padding: 20px;
      max-width: 360px;
      width: 100%;
      background-color: ${({ theme }) => theme.COLORS.WHITE_1};
    }
    .confirm_title {
      margin-bottom: 16px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .confirm_box {
      margin-bottom: 20px;
      border-radius: 8px;
      padding: 12px 16px;
      background-color: ${({ theme }) => theme.COLORS.GRAY_10};
    }
    .confirm_row {
      display: flex;
      justify-content: space-between;
      gap: 12px;
      padding: 4px 0;
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    }
    .confirm_label {
      flex-shrink: 0;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .confirm_value {
      text-align: right;
      word-break: break-word;
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    }
    .confirm_amount {
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_BOLD};
    }
  }
`;
